module.exports = __webpack_public_path__ + "img/28_6.f1d978ce.png";